import { NOZZLE_CONFIG } from './config';

const { POSITIONING, BASE_SCALE } = NOZZLE_CONFIG;

export const getNozzleModelPath = () => NOZZLE_CONFIG.MODEL_PATH;

/**
 * Получить масштаб форсунки в зависимости от глубины
 */
export const getNozzleScale = (depth = null) => {
    const baseScale = BASE_SCALE;
    const baseDepth = POSITIONING.BASE_DEPTH;
    let scaleFactor = 1.0;

    if (depth !== null && depth !== undefined && depth < baseDepth) {
        const minScaleFactor = POSITIONING.MIN_SCALE_FACTOR;
        scaleFactor = minScaleFactor + (1 - minScaleFactor) * (depth / baseDepth);
    }

    return [
        baseScale[0] * scaleFactor,
        baseScale[1] * scaleFactor,
        baseScale[2] * scaleFactor
    ];
};

/**
 * Компенсация смещения от стены при уменьшении масштаба
 */
export const getNozzleWallOffsetCompensation = (depth = null) => {
    if (depth === null || depth === undefined) return 0;

    const baseDepth = POSITIONING.BASE_DEPTH;
    const minScaleFactor = POSITIONING.MIN_SCALE_FACTOR;
    const maxComp = POSITIONING.MAX_WALL_OFFSET_COMPENSATION ?? 0;

    if (depth >= baseDepth) return 0;

    const scaleFactor = minScaleFactor + (1 - minScaleFactor) * (depth / baseDepth);
    return (1 - scaleFactor) * maxComp;
};

/**
 * Получить параметры модели 
 */
export const getNozzleModelParams = (nozzleName, depth) => {
    const scale = getNozzleScale(depth);
    const wallOffsetCompensation = getNozzleWallOffsetCompensation(depth);
    const baseWallOffset = POSITIONING.BASE_WALL_OFFSET ?? 0.013;
    const minEffectiveWallOffset = POSITIONING.MIN_EFFECTIVE_WALL_OFFSET ?? 0;
    const effectiveWallOffset = Math.max(minEffectiveWallOffset, baseWallOffset - wallOffsetCompensation);

    return {
        scale,
        wallOffset: effectiveWallOffset,
        wallOffsetCompensation,
        heightCompensation: 0
    };
};
